<template>
    <v-app id="inspire">
    <Appbar/>
    <v-main :class="isMessengerPage ? 'white' : 'grey lighten-3'">
        <router-view class="main-div pb-10" :class="{ 'messenger-page': isMessengerPage }"/>
    </v-main>
    <Footer v-resize="onResize" v-if="isShowFooter && dymamicShowFooter"/>
    </v-app>
</template>

<script>
import Appbar from '../components/Appbar.vue';
import Footer from '../components/Footer.vue';

export default {
    data: () => ({
        dymamicShowFooter: true,
        expanded: false
    }),
    components: {
        Appbar,
        Footer
    },
    methods: {
        onResize () {
            // const x = window.innerWidth;
            // if(x < 600){
            //     this.expanded = true;
            // }else{
            //     this.expanded = false;
            // }
        }
    },
    computed: {
        isShowFooter(){
            return -1 == ['Login', 'Register'].indexOf(this.$route.name);
        },
        isMessengerPage(){
            return -1 != ['MessengerPrivacy', 'MessengerAccountDeletion', 'MessengerLegalPreview'].indexOf(this.$route.name);
        }
    },
    watch: {
        '$route.name'(value){
            console.log(value);
        },
        expanded(){ // fix footer not dynamic fit on window size;
            this.dymamicShowFooter = false;
            setTimeout(() => {
                this.dymamicShowFooter = true;
            }, 100);
        }
    }
};
</script>

<style>
    .main-div{
        min-height: 100%;
        background: #1D1B19 url('/images/background.webp') 0% 0% repeat padding-box;
    }

    /* หน้าเอกสาร messenger (นโยบาย/คำขอลบบัญชี) อ่านเป็นเอกสารชั้นเดียว:
       พื้นขาวอยู่ที่ v-main เต็มความกว้างจอ ส่วน container แค่จัดคอลัมน์อ่านตรงกลาง
       ถ้าทาพื้นขาวที่ตัว container (กว้าง 820) พื้นเทาของ v-main จะโผล่ข้าง ๆ เป็นขอบการ์ด */
    .main-div.messenger-page{
        background: transparent;
    }
</style>
